(() => {
  'use strict';
  const connection = navigator.connection;
  if (window.Shopify?.designMode || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const probe = document.createElement('link');
  if (!probe.relList?.supports?.('prefetch')) return;
  const pending = new Set();
  const fetched = new Set();
  let hoverTimer;
  function destination(target) {
    const link = target instanceof Element ? target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || link.hasAttribute('data-no-instant') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.hash) return;
    if (!/\/(products|collections)\/[^/]+\/?$/.test(url.pathname)) return;
    if ([...url.searchParams.keys()].some(key => key !== 'variant')) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    return url.href;
  }
  function prefetch(href) {
    if (!href || document.visibilityState === 'hidden' || fetched.has(href) || fetched.size >= 8 || pending.size >= 2) return;
    fetched.add(href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = href;
    pending.add(href);
    const done = () => pending.delete(href);
    hint.addEventListener('load', done, {once: true});
    hint.addEventListener('error', done, {once: true});
    document.head.appendChild(hint);
    setTimeout(done, 10000);
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    clearTimeout(hoverTimer);
    const href = destination(event.target);
    if (href) hoverTimer = setTimeout(() => prefetch(href), 65);
  }, {passive: true});
  document.addEventListener('pointerout', event => {
    if (destination(event.target) !== destination(event.relatedTarget)) clearTimeout(hoverTimer);
  }, {passive: true});
  document.addEventListener('pointerdown', event => {
    if (event.button === 0) prefetch(destination(event.target));
  }, {passive: true, capture: true});
  document.addEventListener('focusin', event => prefetch(destination(event.target)));
  // Warm only two visible destinations after the current page has loaded.
  // Existing limits, consent-independent document hints and slow-link guards apply.
  function warmVisibleLinks() {
    if (!('IntersectionObserver' in window)) return;
    let budget = 2;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || budget === 0) continue;
        const href = destination(entry.target);
        if (!href || fetched.has(href)) { observer.unobserve(entry.target); continue; }
        const before = fetched.size;
        prefetch(href);
        if (fetched.size > before) {
          budget -= 1;
          observer.unobserve(entry.target);
        }
      }
      if (budget === 0) observer.disconnect();
    }, {threshold: 0.2});
    document.querySelectorAll('a.grid-product__link, a[class*="ai-collection-tabs__item-"]').forEach(link => observer.observe(link));
  }
  function scheduleVisibleLinks() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(warmVisibleLinks, {timeout: 2000});
    else setTimeout(warmVisibleLinks, 250);
  }
  if (document.readyState === 'complete') scheduleVisibleLinks();
  else window.addEventListener('load', scheduleVisibleLinks, {once: true});

})();
